module.exports = __webpack_public_path__ + "assets/low.9787cb26.png";